import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs/internal/Observable';
import {
  Discount,
  PromoCodeResponse,
  PromoType,
} from 'anchor-shared/lib/model/entity/discount';

@Injectable()
export class DiscountDAO extends BaseDAO<Discount> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.DISCOUNT);
  }

  public validatePromoCode(
    promoCode: string,
    type: PromoType,
  ): Observable<PromoCodeResponse> {
    const url =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/promo/validate?promo=${promoCode}&type=${type}`;
    const method = 'GET';
    const headers = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<PromoCodeResponse>(
      url,
      method,
      null,
      null,
      headers,
    );
  }
}
